import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-caller-name-modal',
  templateUrl: './caller-name-modal.component.html',
  styleUrls: ['./caller-name-modal.component.less']
})
export class CallerNameModalComponent {
  readonly nzModalData: { phoneNumber: string } = inject(NZ_MODAL_DATA);

  customerName: string = '';

  constructor(private modalRef: NzModalRef) {}

  confirm(): void {
    this.modalRef.destroy(this.customerName.trim() || null);
  }

  skip(): void {
    this.modalRef.destroy(null);
  }
}
